// extracted by mini-css-extract-plugin
export var alert = "#c41e3d";
export var ash = "#c4c5b2";
export var bannerGreen = "#083d35";
export var bannerPlum = "#4b0c32";
export var beige = "#a99995";
export var beigeGrey = "#d4ccca";
export var black222 = "#222";
export var blackHaze = "#e9ecec";
export var blazeDividerGray = "#414141";
export var blazeGray = "gray";
export var blazeIconBackgroundGray = "#232323";
export var borderGrey = "#ccc";
export var breadcrumb = "6";
export var brightGrey = "#ededed";
export var brightYellow = "#ffe500";
export var bronze = "#53342c";
export var buttonDisabledColor = "#e7c0dc";
export var camelot = "#82285f";
export var capeCod = "#474a4a";
export var cardBackground = "#faf9f7";
export var chatIcon = "999";
export var chatOverlay = "9998";
export var clubFacilitiesHeader = "20";
export var clubFinderPrimaryGreen = "#81d0bd";
export var clubFinderSearchGrey = "#858585";
export var clubFinderSecondaryGreen = "#488c7a";
export var clubFinderTextGrey = "#645751";
export var comingSoonBorderPurple = "#984284";
export var comingSoonPurple = "#b0538c";
export var container = "hK_g";
export var containerForceDesktop = "hK_B2";
export var containerShadow = "hK_B3";
export var cookies = "40";
export var copyrightGray = "#af9e9a";
export var cream = "#fcfcf6";
export var darkGreen = "#23494b";
export var davidLloydBrown = "#53342c";
export var davidLloydGray = "#f6f6f6";
export var davidLloydPurple = "#af2c8a";
export var davidLloydSecondaryPurple = "#881e68";
export var davidLloydTeal = "#008578";
export var davidLloydTransparentPurple = "rgba(250,200,255,.4392156863)";
export var defaultPromoTextColor = "#fff";
export var desktopQuery = "screen and (min-width: 60rem)";
export var disabledBackground = "#d9d9d9";
export var disabledText = "#8d8d8d";
export var dropShadow = "1";
export var dropdown = "7";
export var edward = "#a1a9a9";
export var endActionsWrapper = "hK_B5";
export var error = "#df2020";
export var errorBoundary = "#c80000";
export var extraLargeDesktopQuery = "screen and (min-width: 120rem)";
export var fadedHarbourGold = "#ddc499";
export var fadedHarbourSlateGrey = "#eaebec";
export var grayOlive = "#aaaa91";
export var greenSmoke = "#b2b47b";
export var greyD = "#ddd";
export var greyedOutBackground = "#777";
export var harbourDarkGold = "#9e814f";
export var harbourGold = "#bd9b60";
export var harbourHeaderBorder = "#4b4130";
export var harbourHoverGold = "#aa8c56";
export var harbourHoverGrey = "#4c5e6c";
export var harbourSlateGrey = "#323e48";
export var header = "hK_bt";
export var headerDesktopQuery = "screen and (min-width: 64rem)";
export var hessianBackground = "#eeeee9";
export var highlightGold = "#e1b20c";
export var hoverQuery = "(hover: hover)";
export var iconChatColor = "#a43787";
export var inputActiveBackground = "#fefff0";
export var inputActiveBg = "#888";
export var inputBg = "rgba(255,255,255,.8)";
export var inputDefaultBorder = "rgba(145,170,170,.4)";
export var inputFocusOutline = "#ffdd04";
export var inputPlaceholder = "rgba(71,74,74,.7)";
export var introText = "#2e282c";
export var landscapeQuery = "(orientation: landscape)";
export var largeDesktopQuery = "screen and (min-width: 90rem)";
export var largeTabletQuery = "screen and (min-width: 48rem)";
export var lightGray = "#eee";
export var lightGreen = "#dfe9d9";
export var lightSilver = "#aaa";
export var logo = "hK_L";
export var maxExtraLargeDesktopScreen = "120rem";
export var maxHeaderMobileScreen = "64rem";
export var maxLargeDesktopScreen = "90rem";
export var maxLargeTabletScreen = "60rem";
export var maxMobileScreen = "30rem";
export var maxSmallTabletScreen = "48rem";
export var maxWideDesktopScreen = "80rem";
export var mediumGray = "#e8e8e9";
export var membershipSummaryDarkGray = "#2f2f2f";
export var meridianBackgroundLight = "#fbfdfe";
export var meridianBlue = "#0b3b60";
export var meridianBrightBlue = "#b6c4cf";
export var meridianCoolGray = "#f1f5f9";
export var meridianDarkCoolGray = "#cfd8e3";
export var meridianDarkGrayFooter = "#1a202e";
export var meridianDivider = "#e2e8f0";
export var meridianFadeBlue = "#436783";
export var meridianFieryYellow = "#fcb564";
export var meridianHighlightGrey = "#364152";
export var meridianLightGray = "#64748b";
export var meridianLightGrayFooter = "#27303f";
export var meridianOrange = "#c44914";
export var meridianOrangeHover = "rgba(196,73,20,.5)";
export var meridianPaleOrange = "rgba(196,73,20,.3019607843)";
export var meridianPopupSecondaryActionBackground = "#fff";
export var meridianPopupSecondaryActionBorder = "#fcd9bd";
export var meridianSecondaryBackground = "#fff";
export var meridianSecondaryHighlight = "#fcd9bd";
export var meridianSlateGrey = "#323e48";
export var mobileNav = "60";
export var outerSpace = "#223536";
export var overlay = "10";
export var pageNavigation = "2";
export var paleGold = "#decfb0";
export var paleGrey = "#e8e8e9";
export var paleRed = "#d56b66";
export var payByLinkBlockGrey = "#f7f7f7";
export var pinBorder = "#f5f3f3";
export var pineGlade = "#c2c282";
export var placeHolderTextGrey = "#645751";
export var popup = "55";
export var popupCloseButton = "99";
export var portraitQuery = "(orientation: portrait)";
export var recaptchaBadgePopup = "56";
export var reducedMotionQuery = "(prefers-reduced-motion)";
export var ribbonWrapper = "hK_B4";
export var sageBackground = "#eef1e9";
export var silver = "#a3a3a3";
export var sliderOverlay = "10";
export var smallTabletQuery = "screen and (min-width: 30rem)";
export var transparentGrayOlive = "rgba(170,170,145,.3)";
export var transparentGreenGrey = "rgba(71,74,74,.2)";
export var transparentGreenGreyBackground = "rgba(71,74,74,.1019607843)";
export var vibrant = "#af1172";
export var white = "#fff";
export var wholePageOverlay = "9999";
export var wholePagePopup = "100";
export var wideDesktopQuery = "screen and (min-width: 80rem)";